import { render, staticRenderFns } from "./ClientOrderRepeater.vue?vue&type=template&id=163824f7&scoped=true&"
import script from "./ClientOrderRepeater.vue?vue&type=script&lang=js&"
export * from "./ClientOrderRepeater.vue?vue&type=script&lang=js&"
import style0 from "./ClientOrderRepeater.vue?vue&type=style&index=0&id=163824f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163824f7",
  null
  
)

export default component.exports